import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../app/store/rootReducers';
import { getImageSrc, getLabelsByLanguage } from '../utilites/util';
import { setShouldCallLogin } from '../app/store/cookie/actions';
import Config from '../config/config';
import getPkce from 'oauth-pkce';
import LocalStorageKeys from '../constants/LocalStorageKeys';

type Props = {
  from: string;
  isTextVisible: boolean;
  triggerRedirect?: boolean;
  isIconWhite?: boolean;
  hasIcon?: boolean;
};

const SendToTnAccountContainer: React.FC<Props> = ({
  isIconWhite = true,
  triggerRedirect = false,
  from,
  isTextVisible,
  hasIcon = true,
}) => {
  const dispatch = useDispatch();
  const [oauthUrl, setOauthUrl] = useState<string>('');
  const requestAuthorizationCodeLinkRef = useRef<HTMLAnchorElement>(null);

  const { shouldCallLogin } = useSelector((state: AppState) => state.cookie);
  const { signUp } = getLabelsByLanguage();

  const isOre = !!useSelector((state: AppState) => state.manhattanOrder.order.basket.ore);

  const triggerClick = () => {
    requestAuthorizationCodeLinkRef.current?.click();
  };

  useEffect(() => {
    getPkce(43, (_, { verifier, challenge }) => {
      const url = buildAuthorizationUrl(from, isOre, challenge);
      localStorage.setItem(LocalStorageKeys.CODE_VERIFIER, verifier);
      setOauthUrl(url);
    });
  }, []);

  useEffect(() => {
    const loginStatus = localStorage.getItem(LocalStorageKeys.LOGIN_STATUS);
    const loginStarted = loginStatus === 'started';

    if (shouldCallLogin && !loginStarted) {
      localStorage.setItem('loginStatus', 'started');
      dispatch(setShouldCallLogin(false));
      triggerClick();
    }
  }, [shouldCallLogin]);

  useEffect(() => {
    if (triggerRedirect) {
      triggerClick();
    }
  }, [triggerRedirect]);

  return (
    <>
      <a ref={requestAuthorizationCodeLinkRef} href={oauthUrl}>
        <span id="2" className={`list-item second-level yettel-light-font account-login ytl-mobile-menu-item`}>
          {isTextVisible ? signUp : ''}{' '}
          {hasIcon && (
            <img className="icon" alt="signup" src={getImageSrc('', `account${isIconWhite ? '-white' : ''}`, 'png')} />
          )}
        </span>
      </a>
    </>
  );
};

function buildAuthorizationUrl(from: string, isOre: boolean, codeChallenge: string) {
  const baseUrl = new URL(`${Config.tnAccountDomain}/api/auth`);

  baseUrl.searchParams.set('client_id', Config.tnAccountClientId);
  baseUrl.searchParams.set('redirect_uri', `${Config.domain}${Config.prefixUrl}/session-oauth/`);
  baseUrl.searchParams.set('response_type', 'code');
  baseUrl.searchParams.set('state', JSON.stringify({ from: from }));
  baseUrl.searchParams.set('code_challenge', codeChallenge);
  baseUrl.searchParams.set('code_challenge_method', 'S256');
  baseUrl.searchParams.set('scope', ['user_info', 'user_msisdn', 'ftth_info'].join(' '));

  if (isOre) {
    baseUrl.searchParams.set('email_verification_method', 'code');
  }

  return baseUrl.toString();
}

export default SendToTnAccountContainer;
